import React from "react";
import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePickerView } from "@mui/lab/DatePicker/shared";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { TextField } from "@mui/material";
import { Token } from "../theme";

export const MIN_DATE = new Date("2020-03-01");
export const MAX_DATE = new Date("2030-06-01");
export const CURRENT_YEAR_MAX_DATE = new Date(new Date().getFullYear(), 11, 31);

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  icon?: string;
  rightContent?: React.ReactNode;
  children?: React.ReactNode;
}

export const AppToolbar = ({ title, subtitle, rightContent, children, icon }: Props) => {
  return (
    <Box paddingBottom={0}>
      <Box style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between" }}>
        <div>
          <Typography
            variant="h1"
            style={{
              color: Token.textPrimary,
              fontSize: 20,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              padding: "0 0 12px 0",
            }}
          >
            {icon && <img src={icon} style={{ marginRight: "0.25em" }} />}
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              style={{
                color: Token.textSecondary,
                fontSize: 12,
                fontWeight: 500,
                padding: "0",
                marginTop: "-5px",
                marginBottom: "5px",
                textAlign: "left",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </div>
        {!!rightContent && rightContent}
      </Box>

      <div style={{ display: "flex", marginBottom: "0px", alignItems: "flex-start", marginTop: "0px" }}>{children}</div>
    </Box>
  );
};

interface DatePickerWrapperProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({ children, style, className }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack className={className} style={{ display: "contents", ...style }}>
        {children}
      </Stack>
    </LocalizationProvider>
  );
};

interface DatePickerProps {
  views: DatePickerView;
  minDate?: Date;
  maxDate?: Date;
  label: string;
  inlineLabel?: boolean;
  value: Date | null;
  inputFormat: string;
  onChange: (value: Date | null) => void;
  className?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
}

export const DatePickerComponent: React.FC<DatePickerProps> = ({
  onChange,
  value,
  views,
  label,
  inlineLabel,
  inputFormat,
  className,
  style,
  readOnly,
  ...rest
}) => {
  return (
    <DatePicker
      views={[views]}
      label={inlineLabel ? undefined : label}
      value={value}
      inputFormat={inputFormat}
      onChange={(value) => onChange(value)}
      renderInput={(params: any) => (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            readOnly: !!readOnly,
            ...(inlineLabel ? { style: { color: Token.textPrimary, fontWeight: 600 } } : {}),
          }}
          className={className}
          style={{ marginRight: "10px", textAlignLast: "left", width: 200, ...style }}
          helperText={null}
          size="small"
          label={inlineLabel ? undefined : params.label}
          InputProps={
            inlineLabel
              ? {
                  ...params.InputProps,
                  startAdornment: (
                    <span style={{ color: Token.textTertiary, fontSize: 12, whiteSpace: "nowrap", marginRight: 6 }}>{label}:</span>
                  ),
                }
              : params.InputProps
          }
        />
      )}
      {...rest}
    />
  );
};
